module.exports = __webpack_public_path__ + "img/ja.39095dd2.png";